<template>
  <div>
    <div v-show="$store.state.menuOpen"  @click="$openApp">
    <svg-icon icon-class="openAppMarket" class="openApp"></svg-icon>
    </div>


    <div>

      <market-title></market-title>


    </div>

  </div>


</template>
<script>


import MarketTitle from "@/components/market/marketTitle";
export default {
  name: "market",
  components: {MarketTitle},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.openApp {
  width: 110px;
  height: 40px;
  position: fixed;
  z-index: 10;
  bottom: 82px;
  margin-left:-55px;
  -webkit-user-select: none;

}
</style>
